import React from 'react';
interface SectionHeadingProps {
  id: string;
  eyebrow?: string;
  title: React.ReactNode;
  body?: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  id,
  eyebrow,
  title,
  body,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-147" data-mp="jxqvc0p3mjep">
      {eyebrow && <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-148" data-mp="f3mmtd06q3bi">
          {eyebrow}
        </p>}
      <h2 id={id} className={`${eyebrow ? 'mt-4' : ''} font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]`} data-id="element-149" data-mp="ouzdw2e5spgh">
        {title}
      </h2>
      {body && <p className="mt-5 text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-150" data-mp="ysdk796dbxv2">{body}</p>}
    </div>;
}

/** Gold italic emphasis inside a display heading — echoes "Ready" on the covers. */
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <em className="font-display font-semibold italic text-brand-gold" data-id="element-151" data-mp="gs0b76p61f4u">{children}</em>;
}